// utils
import { cn } from '@/utils';
import { formatDate } from '@/utils/format';
import { useReportContext } from '@/pages/Report/Report.context';
import { useCustomerAttributesQuery } from '@/services/customer/customer/customer.queries';
// assets
import styles from '@/pages/Report/components/ReportMeta/ReportMeta.module.css';

interface ReportMetaProps {
    className?: string;
}

const ReportMeta = ({ className }: ReportMetaProps) => {
    const ctx = useReportContext();
    const fromDate = formatDate(ctx.from_datetime ?? '', 'DD MMM');
    const toDate = formatDate(ctx.to_datetime ?? '', 'DD MMM, YYYY');

    const { data: attributes = {} } = useCustomerAttributesQuery();
    const {
        project_representative_agent_name: agentName,
        project_representative_agent_title: agentTitle,
        project_representative_agent_voice_phone_number: phoneNumber
    } = attributes;

    const period = `${fromDate} - ${toDate}`;
    return (
        <div className={cn(styles.meta, className)}>
            <div>Report period:</div>
            <div className="text-base">{period}</div>
            <div>{agentTitle === '' ? 'Agent title' : `${agentTitle}:`}</div>
            <div className="text-base">
                {agentName === '' ? 'Agent name' : agentName}
            </div>
            <div>AI Phone:</div>
            <div className="text-base">
                {phoneNumber === '' ? (
                    <span className="text-gray-6">
                        No phone number available
                    </span>
                ) : (
                    phoneNumber
                )}
            </div>
        </div>
    );
};

export default ReportMeta;
